import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetBoardUsersRequestType,
  GetBoardUsersResponseType,
} from '../types';

export const getBoardUsers = async ({
  pathParams: { organisationId, boardId },
  queryParams,
}: GetBoardUsersRequestType) => {
  const query = stringifyUrlQuery(queryParams);

  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/users${query}`;
  const { data } = await apiAuthClient.get<GetBoardUsersResponseType>(url);
  return data;
};
